import BusinessLine2 from './BusinessLine2';
export default BusinessLine2;
